<template>
  <section class="common-section">
    <v-container>
      <transition>
        <router-view></router-view>
      </transition>
    </v-container>
  </section>
</template>


<script>
import { mapActions } from 'vuex';
export default {
  name: "Tenants",
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods:{
    ...mapActions([
      'getAllTenants'
    ]),
  },
  created(){
    const self = this;
    self.getAllTenants();
  }
};
</script>

<style>
</style>